import api from "lib/api";

export const dropdownTask = async (params) => {
    return await api.post("/v1/stpTimeSheet/getStpTimeSheetTaskList", params);
};

export const updateMyTimesheet = async (params) => {
    return await api.post("/v1/myTimeSheet/editMyTimeSheet", params);
};

export const getMyTimesheetList = async (params) => {
    return await api.post("v1/myTimeSheet/myTimeSheetPagination", params);
};

export const dropdownProjectByEmpId = async (params) => {
    return await api.post("v1/myTimeSheet/dropdownProjectByEmployeeId", params);
};

export const dropdownRoleByEmpIdAndStpTimeSheetId = async (params) => {
    return await api.post("v1/myTimeSheet/dropdownRoleByEmployeeIdAndStpTimeSheetId", params);
};

export const dropdownTaskByStpTimeSheetId = async (params) => {
    return await api.post("v1/myTimeSheet/dropdownTaskByStpTimeSheetId", params);
};

export const getTimesheetCalendar = async (params) => {
    return await api.post("v1/myTimeSheet/myTimeSheetCalendar", params);
};

export const approveMyTimesheet = async (params) => {
    return await api.post("v1/myTimeSheet/createApproveMyTimeSheet", params);
};

export const deleteMyTimesheet = async (params) => {
    return await api.post("v1/myTimeSheet/deleteMyTimeSheet", params);
};

export const dropdownTaskByRole = async (params) => {
    return await api.post("/v1/stpTimeSheet/dropdownTaskByRole", params);
};

export const getTimesheetListByDay = async (params) => {
    return await api.post("v1/myTimeSheet/getMyTimeSheetListDetailsByEmployeeIdAndDate", params);
};

export const getMyTimesheetById = async (params) => {
    return await api.post("v1/myTimeSheet/myTimeSheetById", params);
};

export const getSubOrdinatesPaging = async (params = {}) => {
    return await api.post("/v1/supervisorManagement/getSubOrdinatesPaging", params);
};

export const getTimesheetPaginationForApprover = async (params = {}) => {
    return await api.post("/v1/myTimeSheet/timeSheetPaginationForApprover", params);
};

export const approveEmployeeTimeSheet = async (params = {}) => {
    return await api.post("/v1/myTimeSheet/approveEmployeeTimeSheet", params);
};

export const getTimesheetDetailsByEmployeeId = async (params = {}) => {
    return await api.post("v1/myTimeSheet/getMyTimeSheetListDetailsByEmployeeIdAndMonthAndProjectId", params);
};

export const approveEmployeeTimeSheetByList = async (params = {}) => {
    return await api.post("/v1/myTimeSheet/approveEmployeeTimeSheetByList", params);
};

export const dropdownProjectForApprover = async (params = {}) => {
    return await api.post("/v1/myTimeSheet/getDropdownProjectForApprover", params);
};